import script from "./LandingDemoTenderTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingDemoTenderTable.vue?vue&type=script&setup=true&lang=js"

import "./LandingDemoTenderTable.vue?vue&type=style&index=0&id=7ea836f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ea836f3"]])

export default __exports__